export const keyCodeMapping = {
    13: "Enter",
    38: "ArrowUp",
    40: "ArrowDown",
    36: "Home",
    35: "End",
    27: "Escape",
    8: "Backspace",
};
export const supportedKeys = [
    "Enter",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
    "Escape",
    "Backspace",
];
const supported = (k) => supportedKeys.indexOf(k) !== -1;
export const toKey = (event) => {
    if (event.keyCode)
        return keyCodeMapping[event.keyCode] || null;
    return supported(event.key) ? event.key : null;
};
